import { useEffect } from 'react';

// WebMCP: expose a few read-only site actions to in-browser AI agents that
// support `navigator.modelContext` (experimental; Chrome EPP). It is a no-op in
// browsers without the API. Every tool is side-effect-free: it returns
// information / links, never mutates anything.
//
// Spec: https://webmachinelearning.github.io/webmcp/

const SITE = 'https://logpulse.io';
const APP = 'https://app.logpulse.io';
const MCP_ENDPOINT = 'https://api.logpulse.io/mcp';

const tools = [
  {
    name: 'logpulse_overview',
    description: 'What LogPulse is: an EU-hosted log management, SIEM and service-intelligence platform with a built-in MCP server for AI agents.',
    inputSchema: { type: 'object', properties: {} },
    async execute() {
      return { content: [{ type: 'text', text: `LogPulse is an EU-hosted platform for log management, SIEM and service intelligence, built on ClickHouse with the LPQL query language. It exposes a remote MCP server so AI agents can search logs, investigate risk, and propose detections/automation for human approval. Learn more: ${SITE}/mcp` }] };
    },
  },
  {
    name: 'connect_logpulse_mcp',
    description: 'How to connect an AI agent (Claude Code, Cursor, Codex) to the LogPulse MCP server.',
    inputSchema: { type: 'object', properties: {} },
    async execute() {
      const text = [
        'LogPulse runs a remote MCP server over Streamable HTTP.',
        `Endpoint: ${MCP_ENDPOINT}`,
        `Auth: a bearer token. Mint a PAT (lpat_…) at ${APP}/profile?tab=tokens, or use OAuth 2.1.`,
        '',
        'Claude Code:',
        `claude mcp add logpulse --transport http ${MCP_ENDPOINT} --header "Authorization: Bearer lpat_your_token"`,
        '',
        `Docs: ${SITE}/docs/integrations/mcp-server`,
      ].join('\n');
      return { content: [{ type: 'text', text }] };
    },
  },
  {
    name: 'start_logpulse',
    description: 'Get the URLs to start using LogPulse: sign in / free trial, book a demo, or contact the team.',
    inputSchema: { type: 'object', properties: {} },
    async execute() {
      return { content: [{ type: 'text', text: `Start LogPulse at ${APP}/sign-in . Book a demo at ${SITE}/demo or contact the team at ${SITE}/contact .` }] };
    },
  },
];

/** Registers the WebMCP tools once at app start. Renders nothing. */
export function WebMcpTools(): null {
  useEffect(() => {
    try {
      const nav = navigator as unknown as { modelContext?: { provideContext?: (config: unknown) => void } };
      nav.modelContext?.provideContext?.({ tools });
    } catch {
      // Experimental API: ignore if unavailable or it throws.
    }
  }, []);
  return null;
}
